export enum DisputesExportEnum {
  TITLE = 'Warning: Download Limit Reached',
  DESCRIPTION = 'The system will only download a max of 10,000 rows.',
  CONTINUE = 'Continue',
  CANCEL = 'Cancel',
}
